<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="768" height="768" viewBox="0 0 768 768">
  <path fill="white" d="M384 0c-212.088 0-384 171.936-384 384s171.912 384 384 384 384-171.936 384-384c0-212.064-171.912-384-384-384zM384 672c-159.048 0-288-128.952-288-288s128.952-288 288-288 288 128.952 288 288-128.952 288-288 288zM552 336h-120v-168c0-13.248-10.728-24-24-24h-48c-13.272 0-24 10.752-24 24v240c0 13.272 10.728 24 24 24h192c13.272 0 24-10.728 24-24v-48c0-13.272-10.728-24-24-24z"></path>
</svg>
</template>
